import { IRecoveryState } from '../types/recoveryTypes';

export const INITIAL_RECOVERY = '@@b2b_portal_ui/authorization/INITIAL_RECOVERY';
export const LOGIN_RECOVERY = '@@b2b_portal_ui/authorization/LOGIN_RECOVERY';
export const LOGIN_RECOVERY_FAILED = '@@b2b_portal_ui/authorization/LOGIN_RECOVERY_FAILED';
export const LOGIN_RECOVERY_SUCCESSFUL = '@@b2b_portal_ui/authorization/LOGIN_RECOVERY_SUCCESSFUL';
export const LOGIN_RECOVERY_ANSWER = '@@b2b_portal_ui/authorization/LOGIN_RECOVERY_ANSWER';
export const LOGIN_RECOVERY_ANSWER_FAILED = '@@b2b_portal_ui/authorization/LOGIN_RECOVERY_ANSWER_FAILED';
export const LOGIN_RECOVERY_ANSWER_SUCCESSFUL = '@@b2b_portal_ui/authorization/LOGIN_RECOVERY_ANSWER_SUCCESSFUL';
export const LOGIN_RECOVERY_RESET = '@@b2b_portal_ui/authorization/LOGIN_RECOVERY_RESET';

export const initialRecoveryState: IRecoveryState = {
    loginRecovery: null,
    recoveryAnswer: null,
    errorMessage: '',
};
